import { Component, OnDestroy, OnInit } from '@angular/core';


import { MainLayoutComponent } from 'src/app/shared/components/main-layout/main-layout.component';
import { BlogPostCardComponent } from 'src/app/shared/components/blog-post-card/blog-post-card.component';
import { Observable, Subscription, of } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { BlogPost, FormData, Topic } from 'src/app/services/data.model';
import { BLOG_POST_LIST } from 'src/app/shared/constants/constants';
import { BrandService } from 'src/app/services/brand.service';
import { BrandKey } from 'src/app/shared/constants/brand.constants';

const ARMORVUE_BLOG_POSTS: BlogPost[] = [
  {
    unique_name: 'financing',
    title: 'Flexible Financing',
    text: '<p>Find a payment plan that fits your budget and get started today. Choose from options designed to make your home project more affordable.</p>',
    image: {
      description: 'Couple looking at a phone and laptop',
      url: 'assets/images/financing-plans.jpg',
    },
    read_more_button: {
      text: 'Discover Financing Options',
      link: 'https://armorvue.com/offers/financing/',
    },
  },
  {
    unique_name: 'hurricane',
    title: 'Hurricane Season Starts Here',
    text: '<p>Take proactive steps to help safeguard your home with products designed for performance during severe weather conditions.</p>',
    image: {
      description: 'Hurricane preparedness',
      url: 'assets/images/installation-process.jpg',
    },
    read_more_button: {
      text: 'Discover Hurricane Solutions',
      link: 'https://armorvue.com/hurricane-preparedness/',
    },
  },
  {
    unique_name: 'offers',
    title: 'Exclusive Deals',
    text: '<p>Explore current offers on premium home improvement products and find the right solution for your budget.</p>',
    image: {
      description: 'Exclusive deals and offers',
      url: 'assets/images/energy-efficiency.jpg',
    },
    read_more_button: {
      text: 'Discover Available Offers',
      link: 'https://armorvue.com/offers/',
    },
  },
];

const NEWSOUTH_BLOG_POSTS: BlogPost[] = [
  {
    unique_name: 'financing',
    title: 'Flexible Financing',
    text: '<p>Find a payment plan that fits your budget and get started today. Choose from options designed to make your home project more affordable.</p>',
    image: {
      description: 'Couple looking at a phone and laptop',
      url: 'assets/images/financing-plans.jpg',
    },
    read_more_button: {
      text: 'Discover Financing Options',
      link: 'https://newsouthwindow.com/easy-low-payments/',
    },
  },
  {
    unique_name: 'hurricane',
    title: 'Hurricane Season Starts Here',
    text: '<p>Take proactive steps to help safeguard your home with products designed for performance during severe weather conditions.</p>',
    image: {
      description: 'Hurricane preparedness',
      url: 'assets/images/installation-process.jpg',
    },
    read_more_button: {
      text: 'Discover Hurricane Solutions',
      link: 'https://newsouthwindow.com/impact-windows/',
    },
  },
  {
    unique_name: 'offers',
    title: 'Exclusive Deals',
    text: '<p>Explore current offers on premium home improvement products and find the right solution for your budget.</p>',
    image: {
      description: 'Exclusive deals and offers',
      url: 'assets/images/energy-efficiency.jpg',
    },
    read_more_button: {
      text: 'Discover Available Offers',
      link: 'https://newsouthwindow.com/specials/',
    },
  },
];

@Component({
  selector: 'app-explore-resources',
  standalone: true,
  imports: [
    MainLayoutComponent,
    BlogPostCardComponent
],
  templateUrl: './explore-resources.component.html',
  styleUrl: './explore-resources.component.scss',
})
export class ExploreResourcesComponent implements OnInit, OnDestroy {
  blogPosts: BlogPost[];
  brandKey: BrandKey = 'windownation';
  sub: Subscription;
  constructor(
    private dataService: DataService,
    private brandService: BrandService,
  ) {}

  ngOnInit() {
    this.brandKey = this.brandService.getCurrentBrandKey();
    if (this.brandKey === 'armorvue') {
      this.blogPosts = ARMORVUE_BLOG_POSTS;
    } else if (this.brandKey === 'newsouth') {
      this.blogPosts = NEWSOUTH_BLOG_POSTS;
    } else if (this.dataService.id) {
      this.sub = this.dataService
        .getStepsData(this.dataService.id)
        .subscribe((data) => {
          this.setupBlogPosts(data);
        });
    }
  }

  setupBlogPosts(data: FormData): void {
    const sessionData = JSON.parse(data.sessionData);
    const selectedTopics = sessionData.topics;
    if (selectedTopics.length === 0) {
      this.blogPosts = this.getRandomItems(BLOG_POST_LIST, 3);
    } else {
      const selectedItems = BLOG_POST_LIST.filter((item: BlogPost) =>
        selectedTopics.some(
          (topic: Topic) => topic.unique_name === item.unique_name
        )
      );
      const remainingItems = BLOG_POST_LIST.filter(
        (item) =>
          !selectedTopics.some(
            (topic: Topic) => topic.unique_name === item.unique_name
          )
      );
      const additionalItems = this.getRandomItems(
        remainingItems,
        3 - selectedItems.length
      );

      this.blogPosts = [...selectedItems, ...additionalItems];
    }
  }

  getRandomItems(array: BlogPost[], count: number): BlogPost[] {
    const shuffledArray = [...array].sort(() => Math.random() - 0.5);
    return shuffledArray.slice(0, count);
  }

  onClickBack = (): Observable<any> => {
    return of(true);
  };

  ngOnDestroy(): void {
    if (this.sub) this.sub.unsubscribe();
  }
}
